import { bool, number, oneOfType, shape, string } from 'prop-types';

// general
export const PLACEMENT_AD_TYPE_CHART_FILE_NAME = 'placement_ad_type_chart';
export const PLACEMENT_AD_TYPE_TABLE_FILE_NAME = 'placement_ad_type_table';
export const PLACEMENT_STATION_CHART_FILE_NAME = 'placement_station_chart';
export const PLACEMENT_STATION_TABLE_FILE_NAME = 'placement_station_table';
export const ADS_ICON_TOOLTIP_TEXT = `Recommended 50+ ads for statistical relevance`;

// types
export const TYPE_LIVE_READ = { id: 1, name: 'Live Reads' };
export const TYPE_PRE_RECORDED = { id: 2, name: 'Pre-recorded Spots' };
export const TYPE_WATCHLIST = { id: 3, name: 'Watchlists (Mentions)' };

// options
export const VISITS_OF_ADS_OPTION = 'visitOfads';
export const AVG_AD_COST_OPTION = 'avgAdCost';
export const AD_VISITS_OPTION = 'adVisit';
export const AD_USERS_OPTION = 'adUsers';
export const NEW_AD_USERS = 'newAdUsers';

// shapes
export const adTypeShape = shape({
  type_name: string,
  type_id: number,
  aired: number,
  adVisit: number,
  visitOfads: number,
  adUser: number,
  newAdUsers: number,
  sumAvgAdCost: number,
  avgAdCost: number
});
export const stationShape = shape({
  stationName: string,
  aired: number,
  adVisit: number,
  visitOfads: number,
  stationId: oneOfType([string, number]),
  isStation: bool,
  adUser: number,
  newAdUsers: number,
  sumAvgAdCost: number,
  avgAdCost: number
});

export const typeOptions = {
  [VISITS_OF_ADS_OPTION]: {
    value: VISITS_OF_ADS_OPTION,
    label: 'Ad Visits/Ads'
  },
  [AD_VISITS_OPTION]: {
    value: AD_VISITS_OPTION,
    label: 'Ad Visits'
  },
  [AD_USERS_OPTION]: {
    value: AD_USERS_OPTION,
    label: 'Ad Users'
  },
  [AVG_AD_COST_OPTION]: {
    value: AVG_AD_COST_OPTION,
    label: 'Avg. Ad Cost'
  },
  [NEW_AD_USERS]: {
    value: NEW_AD_USERS,
    label: 'New Ad Users'
  }
}
